import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '@/entities/authSlice';
import { api } from '../api';
import { errorHandler } from '../api/errorHandler';
import { didoxApi } from '@/entities/didox/api';
import { ihamkorApi } from '@/entities/ihamkor/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [api.reducerPath]: api.reducer,
    [didoxApi.reducerPath]: didoxApi.reducer,
    [ihamkorApi.reducerPath]: ihamkorApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      didoxApi.middleware,
      api.middleware,
      ihamkorApi.middleware,
      errorHandler
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
